import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, catchError, EMPTY, Observable, timeout } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PingService {

  public _offline$ = new BehaviorSubject<boolean>(false);

  get offline$(): Observable<boolean> {
    return this._offline$.asObservable();
  }

  public _down$ = new BehaviorSubject<boolean>(false);

  get down$(): Observable<boolean> {
    return this._down$.asObservable();
  }

  constructor(private http: HttpClient) { }

  ping() {
    this.http.get(`${environment.api()}/ping`).subscribe(
      () => {
        this._offline$.next(false);
      }
    );
  }
}
